<template>
  <div>
    <div class="mb-1">Excluded:</div>
    <div class="d-flex flex-wrap">
      <item
          v-for="item in items"
          v-bind="item"
          :key="item.id"
          class="badge badge-purple mr-1 mb-1"
      ></item>
    </div>
  </div>
</template>

<script>
import Item from './exception-list-item';

export default {
  components: {
    Item,
  },

  props: {
    items: Array,
  },
}
</script>
